import React from 'react';
import { FaqData } from '../types';
import { createTrackingCallback } from '../../utils/getPageSectionName';
const isSsr = typeof window === 'undefined';

type FaqSectionProps = {
  faq: FaqData[];
  type?: string;
  pageUrl?: string;
  title?: string;
  bookNowString?: string;
  pageName?: string;
};

export default function FaqSection({
  faq,
  pageUrl,
  type,
  title = 'Frequently Asked Questions',
  bookNowString = 'Book Now',
  pageName
}: FaqSectionProps) {
  return (
    <section>
      <h2 className="railSeoWrap__faq--title font22 latoBold appendBottom15">{title}</h2>
      <div className="railSeoWrap__faq">
        <ul itemScope itemType="http://schema.org/FAQPage">
          {faq?.length > 0 &&
            faq.map(({ question, answer }) => (
              <li className="makeFlex column font14 appendBottom20" key={question}>
                <div itemProp="mainEntity" itemScope itemType="http://schema.org/Question">
                  <h3 className="lineHeight28">
                    <span
                      style={{ wordBreak: 'break-word' }}
                      className="appendBottom5"
                      itemProp="name"
                      dangerouslySetInnerHTML={{
                        __html: question
                      }}
                    />
                  </h3>
                  <div
                    className="darkGreyText lineHeight20 appendTop10"
                    itemProp="acceptedAnswer"
                    itemScope
                    itemType="http://schema.org/Answer"
                  >
                    <div itemProp="text">
                      <p
                        style={{ wordBreak: 'break-word' }}
                        dangerouslySetInnerHTML={{
                          __html: isSsr ? answer : unescape(answer)
                        }}
                      />
                      &nbsp;
                      {pageUrl && (
                        <a
                          className="bookNow"
                          href={pageUrl}
                          onClick={createTrackingCallback(pageName, 'rail_seo_{{pageSectionName}}_faq_booknow')}
                        >
                          {bookNowString}
                        </a>
                      )}
                    </div>
                  </div>
                </div>
              </li>
            ))}
        </ul>
        {type === 'covidSpecialTrains' ||
          (type === 'festiveSpecialTrains' && <div className="latoBlack appendBottom10">Have a safe journey!</div>)}
        {type === 'tatkalTrains' && (
          <div className="latoBlack appendBottom10">
            Ready to <a href="https://www.makemytrip.com/railways/">book your tatkal tickets</a>? Happy travelling!
          </div>
        )}
      </div>
    </section>
  );
}
